import list from './service-list/index.vue';
import detail from './service-detail/index.vue';
import apply from './service-apply/index.vue';
export default [
  {
    path: 'list',
    component: list,
    meta: {
      title: ''
    },
    breadCrumbShowIndexArr: [0, 1, 2]
  },
  {
    path: 'detail',
    component: detail,
    meta: {
      title: '生产托管详情',
      breadCrumbShowIndexArr: [1, 2]
    }
  },
  {
    path: 'apply',
    component: apply,
    meta: {
      title: ''
    },
    breadCrumbShowIndexArr: [0, 1, 2]
  }
];
